// action
import {
    SYSTEM_USER_DETAIL,
    SYSTEM_USER_DETAIL_FAIL,
    SYSTEM_USER_DETAIL_SUCCESS,
    SYSTEM_USER_DETAIL_RESET
} from '../action/systemUserDetailAction'

// initialState
const initialState = {
    apiState: "",
    data: {}
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SYSTEM_USER_DETAIL:
            return {
                ...state,
                apiState: "loading"
            }
        case SYSTEM_USER_DETAIL_FAIL:
            return {
                ...state,
                apiState: "error"
            }
        case SYSTEM_USER_DETAIL_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data
            }
        case SYSTEM_USER_DETAIL_RESET:
            return initialState
        default:
            return state
    }
}